module.exports = __webpack_public_path__ + "img/undraw_reading_list_4boi.d070f5a6.svg";